import { cx } from '@linaria/core';
import { TransitionGroup } from 'react-transition-group';
import { useComponentFrameworkState } from '@provider/component-framework';
import { resets } from '@ui/css';
import { useKatex, IsomorphicPortal, CSSRefTransition } from '@utils/react';
import { dropdown, transitionDurationMs, arrow, dropdownWrapper } from './dropdown.style.js';
import { useA11y } from './hook.a11y.js';
import { usePosition } from './hook.position.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { TransitionSafeFocusOn } from '../../containers/focus-on.js';

function Dropdown(props) {
  const dropdownId = useA11y(props);
  const {
    floating,
    arrowRef
  } = usePosition(props);
  const targetSelector = useComponentFrameworkState(state => state.overlayContainerSelector);
  const target = targetSelector && document.querySelector(targetSelector) || undefined;
  const onClickOutside = evt => {
    // In case we're clicking on the trigger, then do nothing. The trigger
    // itself should handle closing the dropdown
    if (evt.target instanceof HTMLElement && props.triggerRef.current?.contains(evt.target)) {
      return;
    }
    props.onClose(evt);
  };
  useKatex(floating.refs.floating, [props.active]);
  return /*#__PURE__*/jsx(IsomorphicPortal, {
    target: target,
    children: /*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: props.active && /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: transitionDurationMs,
        classNames: dropdown,
        children: ref =>
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        jsx("div", {
          id: dropdownId,
          className: cx(resets.rootCls, props.className, dropdownWrapper),
          ref: floating.refs.setFloating,
          onClick: evt => evt.stopPropagation(),
          style: {
            position: floating.strategy,
            left: floating.x ?? 0,
            top: floating.y ?? 0
          },
          children: /*#__PURE__*/jsxs("div", {
            ref: ref,
            className: dropdown,
            "data-placement": floating.placement,
            children: [props.withArrow && /*#__PURE__*/jsx("i", {
              ref: arrowRef,
              style: {
                left: floating.middlewareData.arrow?.x,
                top: floating.middlewareData.arrow?.y
              },
              className: arrow,
              "data-placement": floating.placement
            }), /*#__PURE__*/jsx(TransitionSafeFocusOn, {
              enabled: !props.disableFocusOn,
              transitionEnterDuration: transitionDurationMs.enter,
              onEscapeKey: props.onClose,
              onClickOutside: onClickOutside,
              focusLock: true,
              returnFocus: props.restoreFocus,
              scrollLock: false,
              noIsolation: true,
              allowPinchZoom: true,
              autoFocus: true,
              preventScrollOnFocus: true,
              children: props.children
            })]
          })
        })
      })
    })
  });
}

export { Dropdown };
//# sourceMappingURL=dropdown.js.map
